import { Badge, Box, Icon } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { postCart } from 'services/api/modules/recruitment/cart'

const AddToCartModal = ({ id }) => {
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)
  const handleModalOpen = () => setOpen(true)
  const handleModalClose = () => setOpen(false)
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false)
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false)
  const [data, setData] = useState([])

  const changeApplicantDetail = (info) => {
    setData(info)
  }

  const {
    mutate: addToCartMutate,
    isLoading: addToCartIsLoading,
    isSuccess: addToCartIsSuccess,
  } = useMutation((data) => postCart(data), {
    onSuccess: async (response) => {
      queryClient.invalidateQueries('getAllApplicant')
      console.log(response)

      queryClient.invalidateQueries('getCart')
      queryClient.resetQueries('getCart')

      changeApplicantDetail(response.data)
      setSuccessSnackbarOpen(true)
      setTimeout(() => {
        handleModalClose()
      }, 1000)
    },
    onError: (error) => {
      console.error(error)
      setErrorSnackbarOpen(true)
    },
  })
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Badge badgeContent={'+'}>
        <Icon sx={{ fontSize: '24px', color: 'alternate.main' }} onClick={handleModalOpen}>
          shopping_cart
        </Icon>
      </Badge>
      <SnackbarRecruitment
        autoHideDuration={4000}
        status="error"
        TransitionComponent="slide"
        message="An error has occured. Please try again"
        open={errorSnackbarOpen}
        handleClose={() => setErrorSnackbarOpen(false)}
      />
      <SnackbarRecruitment
        autoHideDuration={4000}
        status="success"
        TransitionComponent="slide"
        message="Applicant added to cart"
        open={successSnackbarOpen}
        handleClose={() => setSuccessSnackbarOpen(false)}
      />
      <AdxInfoModal
        modalWidth={600}
        muiIcon="error_icon"
        open={open}
        onClose={handleModalClose}
        iconColor="yellow-01.main"
        title="Confirm add applicant to cart?"
        subtitle="Are you sure you want to add this applicant to the cart?"
        footerButtons
        firstBtnLabel={
          addToCartIsSuccess
            ? 'Added to cart!'
            : addToCartIsLoading
            ? 'Adding to cart'
            : 'Add to cart'
        }
        firstBtnHandle={() => {
          addToCartMutate({
            item_type: 'jobseeker',
            item_id: id,
            quantity: 1,
          })
        }}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleModalClose}
      ></AdxInfoModal>
    </Box>
  )
}

export default AddToCartModal
